import { isNil, omitBy } from 'lodash'

import { ApiResponse } from '@marketplace-web/shared/api-client'
import { SaveTransactionShippingContactArgs } from 'types/api/arguments/save-transaction-shipping-contact-args'

import { api } from './api'

export const saveTransactionShippingContact = (args: SaveTransactionShippingContactArgs) =>
  api.post<ApiResponse>(`/transactions/${args.transactionId}/shipping_contact`, {
    save_for_later: args.saveForLater,
    shipping_contact: omitBy(
      {
        buyer_phone_number: args.buyerPhoneNumber,
        seller_phone_number: args.sellerPhoneNumber,
      },
      isNil,
    ),
  })
